import { Badge, Box, Group, Stack, Text } from '@mantine/core';

import FiltersMultiSelect from '../../filtersMultiSelect/FiltersMultiSelect';

const FilterTopToolbar = ({ filterOptions, rightSection }) => {
    return (
        <Group
            ms={'xs'}
            gap={'xs'}
            align='flex-start'
            w={'100%'}>
            <FiltersMultiSelect options={filterOptions} />
            {rightSection}
        </Group>
    );
};
export default FilterTopToolbar;
